var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "header" }, [
    _c("span", { staticClass: "header-title" }, [
      _vm._v(_vm._s(_vm.headTitle))
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "header-user" },
      [
        _c(
          "el-dropdown",
          { attrs: { trigger: "click" }, on: { command: _vm.clickUser } },
          [
            _c("span", { staticClass: "el-dropdown-link" }, [
              _vm._v("\n        " + _vm._s(_vm.user.name) + "\n        "),
              _c("i", { staticClass: "el-icon-arrow-down el-icon--right" })
            ]),
            _vm._v(" "),
            _c(
              "el-dropdown-menu",
              { attrs: { slot: "dropdown" }, slot: "dropdown" },
              [
                _vm.user.role === "teacher"
                  ? _c(
                      "el-dropdown-item",
                      { attrs: { command: "personalCenter" } },
                      [_vm._v("个人中心")]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.user.role === "institution_admin" ||
                _vm.user.role === "school_admin"
                  ? _c(
                      "el-dropdown-item",
                      { attrs: { command: "personalCenter" } },
                      [_vm._v("修改密码")]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("el-dropdown-item", { attrs: { command: "logout" } }, [
                  _vm._v("退出")
                ])
              ],
              1
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-1f234af1", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-1f234af1","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/common/Header.vue
// module id = null
// module chunks = 